import {
  Headings,
  Button,
  Image,
  Paragraph,
  Label,
  Loader,
} from '@sentara-health/optimahealth_web';
import { useState, useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import manageMedication from '../../assets/images/manageMedication.png';
import prescriptionDelivery from '../../assets/images/prescriptionDelivery.png';
import pharmacy from '../../assets/images/pharmacy.png';
import pharmacyMedication from '../../assets/images/pharmacyMedication.png';
import { errorhandler, navigateToExternalUrl,RightArrowIcon } from 'common';
import { useMySSOUrl } from '@sentara-health/sentara-api-hooks-core';
import { GlobalContext, isAvMed } from 'context';
import { CareTile } from 'templates';

function PharmacyTools() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loader, setLoader] = useState<boolean>(false);
  const { SSOUrlType } = useMySSOUrl();
  const { getFeature, ssoEndPoints } = useContext(GlobalContext);
 
  const openUrl = (url: string | undefined) => {
    window.open(url, isAvMed() ? '_blank' : '_self');
  };

  const learMore = async () => {
    const url = getFeature?.PharmacyBenefitsManager
      ? 'EsiRx?source=orderrx'
      : 'OptumRx';

    setLoader(true);
    const res = await SSOUrlType(url);
    if (res?.data?.ssoUrl) {
      navigateToExternalUrl(res?.data?.ssoUrl);
    } else if (res?.errorCode) {
      errorhandler(res?.errorCode);
    }
    setLoader(false);
  };
  // Redirect to SSO URL 
  const redirectUrl = (urltype:string,type:string) => {
  if (isAvMed()){
    openUrl(urltype);
  }else{
     navigate(type) ;
  } 
};
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      redirectUrl(ssoEndPoints?.VirtualVisitSSO,ssoEndPoints?.virtualVisitUrl);
    }
  };

  return (
    <div>
      {loader && <Loader dataTestId="loader" />}
      <div
        data-testid="back"
        className="d-flex flex-row align-items-center cursor-pointer"
        onClick={() => redirectUrl(ssoEndPoints?.VirtualVisitSSO,ssoEndPoints?.virtualVisitUrl)}
        role="button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        <span className="arrow-back-black" />
        <Headings
          level={1}
          text={t('pharmacyTools.title')}
          variant="semiBold"
          dataTestId="PharmacyToolsHeader"
        />
      </div>
      <div className="d-flex flex-column my-2">
        <div className="row py-4">
          <div className="col-md-6">
            <Image
              dataTestId={'managemedicationImage'}
              className="rounded-4 img-fluid"
              path={manageMedication}
            />
          </div>
          <div className="d-flex flex-column col-md-6 justify-content-between mt-3 mt-md-0">
            <Headings
              level={2}
              text={t('pharmacyTools.manageYourMedication')}
              variant={'semiBold'}
            />
            <div className="mt-3">
              <Paragraph text={t('pharmacyTools.medicationContent')} variant="regular" dataTestId={'medicationContent'} />
              <ul className="custom-list">
                <li>
                  <Label>{t('pharmacyTools.prescriptionRefills')}</Label>
                  <span>{t('pharmacyTools.orderRefills')}</span>
                </li>
                <li>
                  <Label>
                    {t('pharmacyTools.medicationSynchronization')}
                  </Label>
                  <span>
                    {t('pharmacyTools.medicationSynchronization2')}
                  </span>
                </li>
                <li>
                  <Label>{t('pharmacyTools.personalizedAdvice')}</Label>
                  <span> {t('pharmacyTools.personalizedAdvice2')}</span>
                </li>
              </ul>

              <div className="d-flex align-items-center">
                <Button
                  dataTestId="learnMore"
                  className="btn-links me-0"
                  onClick={() => learMore()}
                  variant="link_btn"
                  iconRight={<RightArrowIcon />}
                   iconStroke="none"
                >
                  {t('pharmacyTools.learnMore')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="row pb-4 pt-0 pt-md-4">
          <div className="col-md-6 justify-content-between order-md-first mt-3 mt-md-0">
            <Headings
              level={2}
              text={t('pharmacyTools.prescriptionDelivery')}
              variant={'semiBold'}
            />
            <Paragraph text={t('pharmacyTools.prescriptionDeliveryContent')} variant="regular" dataTestId={'prescriptionDeliveryContent'} />
            <div className="d-flex align-items-center">
              <Button
                className="btn-links me-0"
                onClick={() => navigateToExternalUrl(ssoEndPoints?.PRESCRIPTION_DELIVERY_URL)}
                variant="link_btn"
                iconRight={<RightArrowIcon />}
                  iconStroke="none"
              >
                {t('pharmacyTools.learnMore')}
              </Button>
            </div>
          </div>
          <div className="col-md-6 order-first">
            <Image
              dataTestId={'prescriptionDeliveryImage'}
              className="rounded-4 img-fluid"
              path={prescriptionDelivery}
            />
          </div>
        </div>


        <div className=" grid-cont plan-grid-cont mx-0 mx-md-1  d-flex gap-3 search-pharmacy">
          <div className=" h-100 flex-1 search-content">
            <div className="row m-0  h-100">
              <div className="col-md-6 col-lg-6 col-xs-12 p-0 h-100 ">
                <Image
                  dataTestId={'pharmacySearchImage'}
                  path={pharmacy}
                  className='img-fluid w-100'
                />
              </div>
              <div className="col-md-6 col-lg-6 col-xs-12 p-4 px-0 px-md-1 px-xl-4 h-100">
                <Headings
                  level={4}
                  text={t('pharmacyTools.searchPharamacy')}
                  variant={'medium'}
                />
                <Paragraph text={t('pharmacyTools.physicalTherapyContent')} variant="regular" dataTestId={'pharmacyToolsContent'} />
                <div className="d-flex align-items-center">
                  <Button
                    dataTestId={'expressScript'}
                    className="btn-links me-0"
                    onClick={() => {
                      navigateToExternalUrl(ssoEndPoints?.expressScript);
                    }}
                    variant="link_btn"
                    iconRight={<RightArrowIcon />}
                    iconStroke="none"
                  >
                    {t('common.continue')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className=" h-100  flex-1 search-content">
            <div className="row  m-0 h-100">
              <div className="col-md-6 col-lg-6 col-xs-12 p-0">
                <Image
                  dataTestId={'pharmacyMedicationImage'}
                  className="img-fluid w-100"
                  path={pharmacyMedication}

                />
              </div>
              <div className="col-md-6 col-lg-6 col-xs-12 p-4 px-0 px-md-1 px-xl-4 d-flex flex-column gap-2">
                <Headings
                  level={4}
                  text={t('pharmacyTools.saveMedication')}
                  variant={'medium'}
                />

                <div className="d-flex align-items-center">
                  <Button
                    dataTestId={'prescriptionDrugs'}
                    className="btn-links me-0"
                    onClick={() => { navigateToExternalUrl(ssoEndPoints?.prescriptionDrugs) }}
                    variant="link_btn"
                    iconRight={<RightArrowIcon />}
                  iconStroke="none"
                  >
                    {t('pharmacyTools.viewDrug')}
                  </Button>
                </div>
                <div className="d-flex align-items-center">
                  <Button
                    dataTestId={'preAuthorization'}
                    className="btn-links me-0"
                    onClick={() => navigateToExternalUrl(ssoEndPoints?.preAuthorization)}
                    variant="link_btn"
                    iconRight={<RightArrowIcon />}
                  iconStroke="none"
                  >
                    {t('pharmacyTools.preAuthorization')}
                  </Button>
                </div>
                <div className="d-flex align-items-center">
                  <Button
                    dataTestId={'PharmacyReimbursement'}
                    className="btn-links me-0"
                    onClick={() => navigateToExternalUrl(ssoEndPoints?.pharmacyReimbursement)}
                    variant="link_btn"
                    iconRight={<RightArrowIcon />}
                    iconStroke="none"
                  >
                    {t('pharmacyTools.pharmacyReimbursement')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid-cont d-flex">
          <div
            className="left-border-white"
            aria-hidden="true"
            data-focusable="false"
          ></div>
          <CareTile
            fontAwesomeIconKey="notes-medical"
            heading={t('pharmacyTools.orderHistory')}
            subHeading={t('pharmacyTools.orderHistoryContent') ?? ''}
            onClick={() => learMore()}
          />

          <CareTile
            fontAwesomeIconKey="file-invoice-dollar"
            heading={t('pharmacyTools.claimHistory')}
            subHeading={t('pharmacyTools.claimsHistory') ?? ''}
            onClick={() => learMore()}
          />
          <CareTile
            fontAwesomeIconKey="capsules"
            heading={t('pharmacyTools.specialtyPharmacy')}
            subHeading={t('pharmacyTools.specialtyPharmacyContent') ?? ''}
            onClick={() => navigateToExternalUrl(ssoEndPoints?.SPECIALTY_PHARMAC_URL)}
          />
          <div
            className="bottom-border-white"
            aria-hidden="true"
            data-focusable="false"
          ></div>
        </div>
      </div>
    </div>
  );
}
export default PharmacyTools;
